import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../Section';
import { TextInput } from '../TextInput';

import { InputWrapper, ColorPreview } from './styles';

export const BrandSection = ({
	companyName,
	appTitle,
	backgroundColor,
	foregroundColor,
	animationIndex,
	onChange,
}) => {
	return (
		<Section title={'Brand Settings'} animationIndex={animationIndex}>
			<InputWrapper>
				<TextInput
					name={'companyName'}
					label={'Company Name'}
					value={companyName}
					onChange={event => {
						onChange({ companyName: event.target.value });
					}}
				/>
			</InputWrapper>
			<InputWrapper>
				<TextInput
					name={'appTitle'}
					label={'App Title'}
					value={appTitle}
					onChange={event => {
						onChange({ appTitle: event.target.value });
					}}
				/>
			</InputWrapper>
			<InputWrapper>
				<TextInput
					name={'backgroundColor'}
					label={'Start Page Background Color'}
					value={backgroundColor}
					onChange={event => {
						onChange({ backgroundColor: event.target.value });
					}}
				/>
				<ColorPreview style={{ backgroundColor }} />
			</InputWrapper>
			<InputWrapper>
				<TextInput
					name={'foregroundColor'}
					label={'Start Page Foreground Color'}
					value={foregroundColor}
					onChange={event => {
						onChange({ foregroundColor: event.target.value });
					}}
				/>
				<ColorPreview style={{ backgroundColor: foregroundColor }} />
			</InputWrapper>
		</Section>
	);
};

BrandSection.propTypes = {
	companyName: PropTypes.string.isRequired,
	appTitle: PropTypes.string.isRequired,
	backgroundColor: PropTypes.string.isRequired,
	foregroundColor: PropTypes.string.isRequired,
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
